module.exports = __webpack_public_path__ + "static/media/hills.9bad2663.png";